import { PDP_IMAGES_REVIEWS_2026_CAMPAIGN_V2 } from './contexts/abtestContextPdpImagesReviewsV2'
import { PDP_LEVERSPHERE_LOOP_EXPERIMENT_CAMPAIGN } from './contexts/abtestContextLeverSphereLoop'
import { ABTestInputCondition } from './abtestV2'
import { PDP_LOADING_TEXT_EXPERIMENT_CAMPAIGN } from './contexts/abtestContextPopupLoadingText'
import { PDP_DISCOUNT_INCENTIVE_CAMPAIGN } from './contexts/abtestContextPdpDiscountIncentive'
import { PDP_SOCIAL_PROOF_EXPERIMENT_CAMPAIGN } from './contexts/abtestContextSocialProof'

export const activeCampaigns: ABTestInputCondition[] = [
  PDP_IMAGES_REVIEWS_2026_CAMPAIGN_V2,
  PDP_LEVERSPHERE_LOOP_EXPERIMENT_CAMPAIGN,
  PDP_LOADING_TEXT_EXPERIMENT_CAMPAIGN,
  PDP_DISCOUNT_INCENTIVE_CAMPAIGN,
  PDP_SOCIAL_PROOF_EXPERIMENT_CAMPAIGN,
]

